module.exports = __webpack_public_path__ + "page_static/img/logo_white.6349b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white.png
// module id = s9k0
// module chunks = 13